/**
 * Rovers (IPM, wiki: Rover and Projects): send the rover to scan one of your
 * planets for a few hours. It always brings back IPM's guaranteed Dark Matter
 * (our Stellar Cores) — 2 / 7 / 15 / 40 for 4 / 12 / 24 / 48 hours — and
 * sometimes a Prospector. The 48-hour mission needs Robotics level 4.
 * With Rover Resupply, the planet being scanned runs ×2.5 faster.
 */

export interface RoverMission {
  readonly hours: number;
  readonly sc: number;
  /** Robotics room level needed (IPM: tier 4 missions at Robotics 4). */
  readonly robotics: number;
}

export const ROVER_MISSIONS: readonly RoverMission[] = [
  { hours: 4, sc: 2, robotics: 0 },
  { hours: 12, sc: 7, robotics: 0 },
  { hours: 24, sc: 15, robotics: 0 },
  { hours: 48, sc: 40, robotics: 4 },
];

/** Chance a mission also finds a Prospector (provisional; IPM finds managers "occasionally"). */
export const ROVER_FIND_CHANCE = 0.2;
/** Rover Scanning Module: +5% chance of finding everything (IPM). */
export const ROVER_SCANNING_BONUS = 0.05;
/** Rover Resupply: the scanned planet's mining, ship speed and cargo ×2.5 (IPM). */
export const ROVER_RESUPPLY = 2.5;
